// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://127.0.0.1:8000/api',
  firebase: {
    apiKey: 'AIzaSyCecmpJbqzwCV__H2XPkL4zmP6Sr_ji_zY',
    authDomain: 'bkhayr-349e9.firebaseapp.com',
    databaseURL: 'https://bkhayr-349e9.firebaseio.com',
    projectId: 'bkhayr-349e9',
    storageBucket: 'bkhayr-349e9.appspot.com',
    messagingSenderId: '949871632803',
    appId: '1:949871632803:web:e055903a39e09a77767a16'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
